import Vue from 'vue';
import VueRouter from 'vue-router';
import Store from '@/store';

import EntranceService from '@/io/entrance.js';

import NotFound from '@/views/NotFound.vue';

import Entrance from '@/views/Entrance.vue';
import WechatBlank from '@/views/WechatBlank.vue';

import Dashboard from '@/views/Dashboard.vue';
import ProjectManage from '@/views/ProjectManage.vue';
import ProjectInfo from '@/views/ProjectInfo.vue';
import ProjectEditManage from '@/views/ProjectEditManage.vue';
import CustomerManage from '@/views/CustomerManage.vue';
import LabelManage from '@/views/LabelManage.vue';
import LabelInfo from '@/views/LabelInfo.vue';
import Certification from '@/views/Certification.vue';
import ContractManage from '@/views/ContractManage.vue';
import RiskControlStatistics from '@/views/RiskControlStatistics.vue';
import PassengerFlowStatistics from '@/views/PassengerFlowStatistics.vue';
import IdentificationLog from '@/views/IdentificationLog.vue';
import AccountManage from '@/views/AccountManage.vue';
import AccountInfo from '@/views/AccountInfo.vue';
import SearchByPicture from '@/views/SearchByPicture.vue';


Vue.use(VueRouter);

let beforeEnter = (to, from, next) => {
  EntranceService.isLogin().then(res => {
    let isLogin = res.status;
    Store.commit('setIsLogin', isLogin);
    if (isLogin) {
      next();
    } else {
      next(`/entrance?redirect=${to.fullPath}`);
    }
  }).catch(() => {});
}

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/entrance',
    name: 'Entrance',
    component: Entrance
  },
  {
    path: '/wechat_blank',
    name: 'WechatBlank',
    component: WechatBlank
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      breadcrumbs: ['控制台'],
    },
    beforeEnter
  },
  {
    path: '/project_manage',
    name: 'ProjectManage',
    component: ProjectManage,
    meta: {
      breadcrumbs: ['项目管理'],
    },
    beforeEnter
  },
  {
    path: '/project_manage/new',
    name: 'NewProject',
    component: ProjectInfo,
    meta: {
      breadcrumbs: ['项目管理', '新增项目'],
    },
    beforeEnter
  },
  {
    path: '/project_manage/edit/:id',
    name: 'EditProject',
    component: ProjectInfo,
    meta: {
      breadcrumbs: ['项目管理', '编辑项目'],
    },
    beforeEnter
  },
  {
    path: '/project_manage/:id',
    name: 'ProjectEditManage',
    component: ProjectEditManage,
    meta: {
      breadcrumbs: ['项目管理', '管理项目'],
    },
    beforeEnter
  },
  {
    path: '/customer_manage',
    name: 'CustomerManage',
    component: CustomerManage,
    meta: {
      breadcrumbs: ['客户管理'],
    },
    beforeEnter
  },
  {
    path: '/label_manage',
    name: 'LabelManage',
    component: LabelManage,
    meta: {
      breadcrumbs: ['标签管理'],
    },
    beforeEnter
  },
  {
    path: '/label_manage/new',
    name: 'NewLabel',
    component: LabelInfo,
    meta: {
      breadcrumbs: ['标签管理', '新增标签'],
    },
    beforeEnter
  },
  {
    path: '/label_manage/edit/:id',
    name: 'EditLabel',
    component: LabelInfo,
    meta: {
      breadcrumbs: ['标签管理', '编辑标签'],
    },
    beforeEnter
  },
  {
    path: '/certification_manage',
    name: 'Certification',
    component: Certification,
    meta: {
      breadcrumbs: ['认证管理'],
    },
    beforeEnter
  },
  {
    path: '/contract_manage',
    name: 'ContractManage',
    component: ContractManage,
    meta: {
      breadcrumbs: ['签约管理'],
    },
    beforeEnter
  },
  {
    path: '/risk_control_statistics',
    name: 'RiskControlStatistics',
    component: RiskControlStatistics,
    meta: {
      breadcrumbs: ['统计分析', '风控统计'],
    },
    beforeEnter
  },
  {
    path: '/passenger_flow_statistics',
    name: 'PassengerFlowStatistics',
    component: PassengerFlowStatistics,
    meta: {
      breadcrumbs: ['统计分析', '客流统计'],
    },
    beforeEnter
  },
  {
    path: '/identification_log',
    name: 'IdentificationLog',
    component: IdentificationLog,
    meta: {
      breadcrumbs: ['识别日志'],
    },
    beforeEnter
  },
  {
    path: '/account_manage',
    name: 'AccountManage',
    component: AccountManage,
    meta: {
      breadcrumbs: ['账号管理'],
    },
    beforeEnter
  },
  {
    path: '/account_manage/new',
    name: 'NewAccount',
    component: AccountInfo,
    meta: {
      breadcrumbs: ['账号管理', '新增账号'],
    },
    beforeEnter
  },
  {
    path: '/account_manage/edit/:id',
    name: 'EditAccount',
    component: AccountInfo,
    meta: {
      breadcrumbs: ['账号管理', '编辑账号'],
    },
    beforeEnter
  },
  {
    path: '/search_by_picture',
    name: 'SearchByPicture',
    component: SearchByPicture,
    meta: {
      breadcrumbs: ['以图搜人'],
    },
    beforeEnter
  },
  {
    path: '*',
    component: NotFound
  }
];

const router = new VueRouter({
  routes
});

export default router;
